<template>
  <div
    :class="[
      'custom-checkbox',
      {
        'custom-checkbox--checked': value
      }
    ]"
    @click="toggle"
  >
    <slot name="icon"></slot>
    <template v-if="!hasSlot('icon')">
      <b-icon :icon="icon" :scale="scale"></b-icon>
    </template>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Custom checkbox
 * ==================================================================================
 **/

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'check'
    },
    scale: {
      type: Number,
      default: 1.5
    }
  },
  data: function() {
    return {}
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    },
    hasSlot(name = 'default') {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    }
  }
}
</script>
